<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="currentColor"
        stroke="none"
        d="M328 85q-8 3-8 11c0 8 3 9 8 11l56 21 21 57q3 7 11 7c8 0 9-3 11-7l21-57 57-21q7-3 7-11c0-8-3-9-7-11l-57-21-21-56q-3-8-11-8c-8 0-9 3-11 8l-21 56zM9 240a16 16 0 0 0 0 29l17 8 8 4h1l88 41 41 88v1l4 8 8 17a16 16 0 0 0 29 0l8-17 4-8v-1l41-88 88-41h1l8-4 17-8a16 16 0 0 0 0-29l-17-8-8-3-1-1-88-41-41-88v-1l-4-8-8-17a16 16 0 0 0-29 0l-8 17-4 8v1l-41 88-88 41-9 4zm83 15 52-24q15-7 23-24l24-51 23 51q7 17 24 24l51 23-51 24q-17 8-24 24l-23 51-24-51q-8-16-23-24zm292 129-56 21q-8 3-8 11c0 8 3 9 8 11l56 21 21 57q3 7 11 7c8 0 9-3 11-7l21-57 57-21q7-3 7-11c0-8-3-9-7-11l-57-21-21-56q-3-8-11-8c-8 0-9 3-11 8z"
      />
    </svg>
  </span>
</template>
